export default __webpack_public_path__ + "static/media/mov.1e1119e2.png";